const games =
{
    helmet :
    {
        title : 'Jeux' ,
        metas : []
    }
};

export default games ;